import React, { useContext } from 'react';
import PaginationContext from '../data/PaginationContext';
import useNewPagination from '../utils/useNewPagination';

var PaginationProvider = function PaginationProvider(_ref) {
  var children = _ref.children,
      initialPage = _ref.initialPage,
      count = _ref.count,
      siblingStretchLength = _ref.siblingStretchLength,
      edgeStretchLength = _ref.edgeStretchLength;
  var pagination = useNewPagination({
    initialPage: initialPage,
    count: count,
    siblingStretchLength: siblingStretchLength,
    edgeStretchLength: edgeStretchLength
  });
  var paginationContext = useContext(PaginationContext);
  return paginationContext ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : /*#__PURE__*/React.createElement(PaginationContext.Provider, {
    value: pagination
  }, children);
};

export default PaginationProvider;